import Vue from "vue";
import Vuex from "vuex";
import { api, baseURL } from "@/api";
import eventBus from "@/shared/eventBus.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userIsLoged: false,
    userAdmin: false,
    userName: null,
    userDisplayName: null,
    favoritesLength: null,
    allNotificationsCount: null,
    notificationsCount: null,
    messagesCount: null,
    connection: null,
    messages: [],
    requestingMessages: false,
    chatVisible: false,
    fbToken: null,
    competitionWork: null,
    userImage: null
  },
  mutations: {
    setCompetitionWork(state, payload) {
      state.competitionWork = payload;
    },
    setFbToken(state, payload) {
      state.fbToken = payload;
    },
    setChatVisible(state, payload) {
      state.chatVisible = payload;
    },
    openWSConnection(state) {
      if (state.connection) {
        state.connection.close();
      }
      let sid = localStorage.getItem("sid");
      if (baseURL === "/api") {
        let loc = window.location;
        let uri = "";
        if (loc.protocol === "https:") {
          uri = "wss:";
        } else {
          uri = "ws:";
        }
        uri += "//" + loc.host;
        uri += "/api/websocket";
        state.connection = new WebSocket(uri + "?sid=" + sid);
      } else {
        state.connection = new WebSocket(
          "wss://081k122.mars-t.mars-hosting.com/api/websocket" + "?sid=" + sid
        );
      }
      // console.log('opend', state.connection)
    },
    closeWSConnection(state) {
      state.connection.close();
    },
    changeUserIsLoged(state, payload) {
      state.userIsLoged = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setUserAdmin(state, payload) {
      state.userAdmin = payload;
    },
    setUserImage(state, payload) {
      state.userImage = payload || null;
    },
    setDisplayName(state, payload) {
      state.userDisplayName = payload;
    },
    changeFavoritesLength(state) {
      if (localStorage.getItem("sid")) {
        api
          .getFavorites()
          .then(res => {
            state.favoritesLength = res.data.data.length;
          })
          .catch(e => {
            // console.log(e)
          });
      }
    },
    setNotificationCounters(state, payload) {
      state.allNotificationsCount = payload.total;
      state.notificationsCount = payload.notification;
      state.messagesCount = payload.message;
    }
  },
  actions: {
    async getMessages(store, payload) {
      let params = {
        id: payload
      };
      let ok = false;
      await api
        .getUserMessages(params)
        .then(res => {
          store.state.messages = res.data.data.reverse();
          eventBus.$emit("scrollMessages");
          ok = true;
        })
        .catch(e => {
          console.log(e);
        });
      if (ok) {
        await api.seenUserMessages(params).catch(e => {
          console.log(e);
        });
        eventBus.$emit("refreshMessages");
      }
    },
    loadMessagesHistory(store, payload) {
      store.state.requestingMessages = true;
      api
        .getUserMessages(payload)
        .then(res => {
          // store.state.messages = store.state.messages.concat(res.data.data)
          for (let row of res.data.data) {
            store.state.messages.unshift(row);
          }
          store.state.requestingMessages = false;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
});
